<template>
    <div class="container">
        <div class="row faqs mx-auto mb-5 pb-5">
            <div class="col-md-12">
                <h1 class="text-center mt-5 mb-5">
                    {{ $t('Support.SupportTitle') }}
                </h1>

                <div class="mb-3">
                    <p class="mb-0"><strong>What if I am having trouble participating in a program?</strong></p>
                    <p>Please email <strong><a href='mailto:help-ZevoWalmart@snippmail.com' target='_blank' aria-label='Send email to help-ZevoWalmart@snippmail.com.com'>help-ZevoWalmart@snippmail.com</a></strong>.
                    </p>
                </div>
                <div class="mb-3">
                    <p class="mb-0"><strong>How long do I have to register for the promotion?</strong></p>
                    <p>Participants will have till October&nbsp;26, 2026 to register.</p>
                </div>
                <div class="mb-3">
                    <p class="mb-0"><strong>How long after my submission will I receive my confirmation?</strong></p>
                    <p>Participants will receive their confirmation in 24 hours after their registration has been processed.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FAQ',
        data() {
            return {
                faqs: [],
                activeIndex: null,
                targetFaqKeyword: 'heading2',
            };
        },
        created() {
            this.loadFaqs();
        },
      mounted() {
    // Open based on URL hash
    const hash = window.location.hash.replace('#', ''); // removes the #
    if (hash) {
        this.targetFaqKeyword = hash;
        this.$nextTick(() => {
            this.openTargetFaq();
        });
    }

    // Open first FAQ on any link click inside this component
    this.$nextTick(() => {
        const links = this.$el.querySelectorAll('a');
        links.forEach((link) => {
            link.addEventListener('click', () => {
                this.activeIndex = 0;
            });
        });
    });
},
        watch: {
            '$i18n.locale': 'loadFaqs',
        },
        methods: {
            async loadFaqs() {
                try {
                    const currentLocale = this.$i18n.locale;
                    const response = await fetch(`/locales/${currentLocale}.json`);
                    const data = await response.json();

                    if (data && data.Support) {
                        this.faqs = data.Support.faqs;
                    } else {
                        console.error('Invalid FAQ data structure in', currentLocale);
                        this.faqs = [];
                    }
                } catch (error) {
                    console.error('Error loading FAQs:', error);
                    this.faqs = [];
                }
            },
            toggle(index) {
                this.activeIndex = this.activeIndex === index ? null : index;
            },
            async openTargetFaq() {
    if (this.faqs.length === 0) {
        await this.loadFaqs();
    }

    const hash = this.targetFaqKeyword.toLowerCase(); // e.g. "heading2"
    const indexMatch = hash.match(/heading(\d+)/);    // extract number → "2"

    if (indexMatch) {
        this.activeIndex = parseInt(indexMatch[1]);   // set index directly → 2
    } else {
        this.activeIndex = 0;
    }

    this.$nextTick(() => {
        const el = document.getElementById(`heading${this.activeIndex}`);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });
},
        },
    };
</script>


